
// api 側の InitialData と同じ形式にする必要があります。

import { CodeName } from './CodeName'

export class InitialData {
  CodeNames?: CodeName[]

  codeNames(codeKbn: string): CodeName[] {
    return this.CodeNames
      ?.filter(x => x.CODE_KBN === codeKbn)
      ?.sort((a, b) => (a.DISPLAY_ORDER ?? 0) - (b.DISPLAY_ORDER ?? 0)) ?? []
  }
}
